import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { AuthLayout } from "@/pages/AuthLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useApp } from "@/context/AppContext";

export default function Register() {
  const { register } = useApp();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 8) return toast.error("Kata sandi minimal 8 karakter.");
    setLoading(true);
    const res = await register(form);
    setLoading(false);
    if (res.error) return toast.error(res.error);
    toast.success("Akun berhasil dibuat!");
    navigate(res.entitled ? "/app" : "/akses");
  };

  return (
    <AuthLayout
      title="Buat akun Scholavia"
      subtitle="Buat akun untuk mengakses Scholavia setelah pembayaran."
      footer={<>Sudah punya akun? <Link to="/login" className="font-semibold text-[#7C3AED] hover:underline">Masuk</Link></>}
    >
      <form onSubmit={submit} className="space-y-4">
        <div>
          <Label htmlFor="name">Nama Lengkap</Label>
          <Input id="name" required data-testid="register-name" placeholder="Nama kamu" value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1.5" />
        </div>
        <div>
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" required data-testid="register-email" placeholder="kamu@email.com" value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1.5" />
        </div>
        <div>
          <Label htmlFor="password">Kata Sandi</Label>
          <Input id="password" type="password" required data-testid="register-password" placeholder="Minimal 8 karakter" value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1.5" />
        </div>
        <Button type="submit" disabled={loading} data-testid="register-submit" className="w-full rounded-xl bg-[#7C3AED] py-5 text-base hover:bg-[#6D28D9]">
          {loading ? "Memproses…" : "Daftar Sekarang"}
        </Button>
      </form>
    </AuthLayout>
  );
}
